import { useTranslation } from 'react-i18next';
import { Icon } from '../primitives';

const SAMPLE_IMAGES = [
  '/img_presets/realistic.webp',
  '/img_presets/birthdayphotosh_mli15ow9.webp',
  '/img_presets/woman_mm84h5fs.webp',
];

const CTA_KEY_BY_FILTER = {
  photo: 'gallery.emptyCreatePhoto',
  video: 'gallery.emptyCreateVideo',
};

export default function GalleryEmptyState({ filter = 'all', onStart }) {
  const { t } = useTranslation();
  const ctaLabel = t(CTA_KEY_BY_FILTER[filter] || 'gallery.emptyStartCreating');

  return (
    <div
      className="flex min-h-[calc(100vh-var(--safe-top,0px)-240px)] flex-col items-center justify-center px-6 pb-28 pt-10 text-center"
      data-testid="gallery-empty-state"
    >
      <div
        className="relative mb-9 h-[190px] w-[320px] max-w-full"
        style={{ perspective: '800px' }}
        aria-hidden="true"
      >
        {SAMPLE_IMAGES.map((src, index) => {
          const offset = index - 1;
          const rotation = offset * 8;
          const translateX = offset * 78;
          const translateY = Math.abs(offset) * 16;
          const zIndex = 5 - Math.abs(offset);

          return (
            <div
              key={src}
              className={`anim-fan anim-fan-${index} absolute left-1/2 top-1/2 h-[172px] w-[124px] overflow-hidden rounded-[22px] border-[6px] border-white bg-surface-2 shadow-2xl`}
              style={{
                zIndex,
                '--fan-tx': `${translateX}px`,
                '--fan-ty': `${translateY}px`,
                '--fan-rot': `${rotation}deg`,
                '--fan-sc': '1',
                boxShadow: '0 12px 34px rgba(0,0,0,0.55)',
              }}
            >
              <img
                src={src}
                alt=""
                className="h-full w-full object-cover"
                loading="eager"
                draggable={false}
              />
            </div>
          );
        })}
      </div>

      <h2 className="mb-8 max-w-[330px] font-sans text-[30px] font-bold leading-[1.18] text-text-primary">
        {t('gallery.emptyTitleLine1')}
        <br />
        {t('gallery.emptyTitleLine2')}
      </h2>

      <button
        type="button"
        onClick={onStart}
        className="flex h-16 min-w-[252px] items-center justify-center gap-3 rounded-full bg-[#2F2F31] px-8 font-sans text-[18px] font-bold text-text-primary transition-transform active:scale-[0.97]"
        data-testid="gallery-empty-cta"
      >
        <span>{ctaLabel}</span>
        <Icon name="sparkle" size={24} className="text-text-primary" />
      </button>
    </div>
  );
}
